import {createSvgIcon} from './utils'

export const BaggageHelpOutlineIcon = createSvgIcon(
  <>
    <path
      clipRule="evenodd"
      d="M7.99901 9.49988C9.84684 9.49988 11.6946 7.72597 11.6946 5.0651C11.6946 2.10857 9.47727 0.999878 7.99901 0.999878C6.52075 0.999878 4.30334 2.10857 4.30334 5.0651C4.30334 7.72597 6.15118 9.49988 7.99901 9.49988ZM7.99901 7.49988C8.53516 7.49988 9.69465 6.84056 9.69465 5.0651C9.69465 4.14064 9.37231 3.68107 9.08416 3.42894C8.73675 3.12495 8.291 2.99988 7.99901 2.99988C7.70702 2.99988 7.26125 3.12496 6.91383 3.42895C6.62568 3.68108 6.30334 4.14065 6.30334 5.0651C6.30334 6.84054 7.46284 7.49988 7.99901 7.49988Z"
      fill="#21201F"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M14.9996 5.99988C13.8951 5.99988 12.9996 6.89531 12.9996 7.99988V12.9999C12.9996 14.1044 13.8951 14.9999 14.9996 14.9999H19.9996C21.1042 14.9999 21.9996 14.1044 21.9996 12.9999V7.99988C21.9996 6.89531 21.1042 5.99988 19.9996 5.99988H14.9996ZM19.9996 7.99988H14.9996V12.9999H19.9996V7.99988Z"
      fill="#21201F"
      fillRule="evenodd"
    />
    <path
      d="M6.86777 12.2755C6.30369 12.1084 5.959 12.1495 5.74744 12.2469C5.56486 12.3309 5.13342 12.6156 4.72976 13.7174C4.31631 14.846 4.00027 16.6665 4.00031 19.4998L4.00012 21.9999H2.00012L2.00031 19.4999C2.00027 16.5486 2.32537 14.4664 2.85182 13.0294C3.37876 11.5911 4.10704 10.8002 4.91129 10.4301C5.71566 10.0599 6.59799 10.1097 7.4358 10.3578C8.27233 10.6056 9.06249 11.0506 9.68242 11.4687C9.85609 11.5858 10.0229 11.7379 10.1581 11.8935L13.4777 15.9997H20.0002V16.9997C20.0002 18.9331 18.4969 21.5333 16.5673 21.6538L10.7479 22.02L8.99974 20.95V18.61L11.2524 19.98L16.4425 19.6577C16.9445 19.6263 17.4996 18.9999 17.6656 17.9997H12.5227L8.6281 13.1823C8.60718 13.1596 8.58567 13.1414 8.56413 13.1268C8.03197 12.7679 7.4328 12.4428 6.86777 12.2755Z"
      fill="#21201F"
    />
  </>,
  'BaggageHelpOutline',
)
